module.exports = __webpack_public_path__ + "img/namihira_patient.1e793e19.jpg";